import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { CommonHttpService } from 'src/app/utils/common-http.service';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { Chart } from 'chart.js';
import { UtilsService } from 'src/app/utils/utils.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-bottombar-data',
  templateUrl: './bottombar-data.component.html',
  styleUrls: ['./bottombar-data.component.scss']
})
export class BottombarDataComponent implements OnInit, OnChanges {
  showThrobberbottomBar: boolean;
  bottomBarData: any[];
  chartData: any[];
  millisInSixHours = ProjConstants.MILLIS_IN_6HOURS;
  gradientStyles: any = {};
  gradientColors: any = [];
  gradient: CanvasGradient;
  bottomTableKeys: string[];
  direction: any;
  abbrvMapping = ProjConstants.COMPONENT_ABBREVIATION_MAPPING;
  bottomBarColumns: any = [];
  Linechart: any;
  yAxisMin: number;
  chartTableData: any[];
  chartOptions: {};
  heightHundred: any = {};
  borderBottomBarStyle = {};
  bottomBarTableStyles: any = {};
  dateList: any[];
  showBottomBar: boolean;

  constructor(
    private httpservice: CommonHttpService,
    private utils: UtilsService,
    private router: Router
  ) {
    this.bottomBarColumns.push('Component');
  }

  @Input() apiParams:any;
  @Output() closePopUp = new EventEmitter<any>();

  ngOnInit() {
  }

  ngOnChanges() {
    this.chartData = [];
    this.direction = [];
    this.bottomBarColumns = [];
    this.gradientStyles = {};
    this.bottomBarData = [];
    this.gradientColors = [];
    if(this.Linechart != null && this.Linechart != undefined) {
      this.Linechart = new Chart('canvas',this.chartOptions).destroy();
      this.Linechart = null;
    }
    this.setData(this.apiParams);
    this.showBottomBar = true;
  }

  setData(apiParams) {
  document.getElementById('bottom-bar').classList.add('active');
  // if (this.router.url.split('/')[1] === 'cyclone' && this.router.url.split('/')[2] === 'forecast') {
  //   apiParams.postData['primarySource'] = 'ECMWF';
  // } else {
  apiParams.postData['primarySource'] = 'IMD_SHORT_RANGE';
  apiParams.postData['secondarySource'] = 'IMD_LONG_RANGE';
  // }
  this.showThrobberbottomBar = true;
  this.httpservice.makePostApiCall(apiParams.url, apiParams.postData).subscribe(data => {
    this.showThrobberbottomBar = false;
    this.bottomBarData = this.setBottomBarData(data);
    this.chartData = this.prepareChartData(this.bottomBarData);
    const canvas = <HTMLCanvasElement>document.getElementById('canvas');
    const ctx = canvas.getContext('2d');
    this.gradient = ctx.createLinearGradient(0, 0, 0, 150);
    this.gradient.addColorStop(0, 'rgba(174, 0, 0, 0.3)');
    this.gradient.addColorStop(0.25, 'rgba(174, 0, 0, 0.2)');
    this.gradient.addColorStop(0.5, 'rgba(255, 255, 255, 0.2)');
    this.gradient.addColorStop(0.75, 'rgba(255, 255, 255, 0.2)');
    this.gradient.addColorStop(0.85, 'rgba(255, 255, 255, 0.2)');
    this.gradient.addColorStop(0.95, 'rgba(255, 255, 255, 0.1)');
    this.gradient.addColorStop(1, 'rgba(255, 255, 255, 1)');
    this.setChartOptions();
    this.Linechart = new Chart('canvas', this.chartOptions);


    for (const i of this.bottomBarData) {
      if (i['Component'] == 'WIND') {
        let gradientString = 'linear-gradient(to right,white,';
        for (const ts of Object.keys(i)) {
          if (ts !== 'Component') {
            this.bottomBarTableStyles[i[ts]] = this.getColorForBottomBar(i['Component'], i[ts]);
            this.gradientColors.push(this.bottomBarTableStyles[i[ts]]['background-color']);
            gradientString = gradientString + (this.bottomBarTableStyles[i[ts]]['background-color']).toString() + ',';
          }
        }
        gradientString = gradientString.toString() + 'white)';
        this.gradientStyles = {
          // 'background': 'linear-gradient(to right,white,white,'+this.gradientColors[0].toString()+','+this.gradientColors[1].toString()+','+this.gradientColors[2].toString() + ',' +this.gradientColors[3].toString()+','+this.gradientColors[4].toString()+','+this.gradientColors[5].toString() +',' +this.gradientColors[6].toString()+','+this.gradientColors[7].toString()+','+this.gradientColors[8].toString()+','+this.gradientColors[9].toString()+','+this.gradientColors[10].toString()+','+this.gradientColors[11].toString() + ',white)'
          // 'background': 'linear-gradient(to right,white,white,white,' + this.gradientColors[0].toString() + ',' + this.gradientColors[1].toString() + ',' + this.gradientColors[2].toString() + ',' + this.gradientColors[3].toString() + ',white)'
          'background': gradientString
        };
      }

    }
    let current_time = new Date().toLocaleTimeString();
    let selected_ts;
    for (const ts of this.bottomBarColumns) {
      const low = new Date(Number(ts - this.millisInSixHours)).toLocaleTimeString();
      const high = new Date(Number(ts)).toLocaleTimeString();
      if (current_time >= low && current_time <= high) {
        selected_ts = ts.toString();
        break;
      }
    }
    // this.popUpData = {};
    // for (let obj of this.bottomBarData) {
    //   this.popUpData[obj['Component']] = obj[selected_ts];
    // }
    this.prepareBottomBarDays(this.bottomBarData);
    // console.log(this.bottomBarData);
  });
  }

  setBottomBarData(data) {
    const tableData = [];
    for (const item of Object.keys(data)) {
      const obj = {};
      const flObj = {};
      const minTpObj = {};
      const minFlObj = {};
      const windAnglesArray = [];
      obj['Component'] = item;
      this.bottomTableKeys = Object.keys(data[item]['data']);
      this.bottomTableKeys.sort();
      flObj['Component'] = 'Feels Like';
      minTpObj['Component'] = 'Min Temperature';
      minFlObj['Component'] = 'Min Feels Like';
      this.direction['Component'] = 'WindDirection';
      // this.bottomTableKeys = this.bottomTableKeys.slice(0, 20);
      this.bottomTableKeys = this.bottomTableKeys.slice(0, 40);
      for (const timestamp of this.bottomTableKeys) {
        if (item === 'TEMPERATURE') {
          // console.log(obj);
          obj[timestamp] = (Number(data[item]['data'][timestamp][this.abbrvMapping[item]]).toFixed(1)).toString();
          flObj[timestamp] = Number(data[item]['data'][timestamp].fl).toFixed(1).toString();
          minTpObj[timestamp] = Number(data[item]['data'][timestamp].minTp).toFixed(1).toString();
          minFlObj[timestamp] = Number(data[item]['data'][timestamp].minFl).toFixed(1).toString();

          } else if (item === 'WIND') {
          obj[timestamp] = Number(data[item]['data'][timestamp]['wg']).toFixed(1);
          // console.log("^^^^^^^^^^^", data[item]['data'][timestamp]['wg']);
          this.direction[timestamp] = this.getAngleinDegrees((Number(data[item]['data'][timestamp].wu)),(Number(data[item]['data'][timestamp].wv)));
          this.direction[timestamp] = this.direction[timestamp].toString() + 'deg';

        } else {
          obj[timestamp] = Number(data[item]['data'][timestamp][this.abbrvMapping[item]]).toFixed(1);
        }
        if (!this.bottomBarColumns.includes(timestamp)) {
          this.bottomBarColumns.push(timestamp);
        }
      }
      tableData.push(obj);
      if (item === 'TEMPERATURE') {
        tableData.push(flObj);
        tableData.push(minTpObj);
        tableData.push(minFlObj);
      }
      // console.log("DIRECTION", this.direction);
    }
    return tableData;
  }

  getAngleinDegrees(uMs,vMs) {
  // vMs comes out upside-down..
  const velocityAbs = Math.sqrt(Math.pow(uMs, 2) + Math.pow(vMs, 2));
  // console.log(velocityAbs);
  const velocityDir = Math.atan2(uMs / velocityAbs, vMs / velocityAbs);
  // console.log(velocityDir)
  let velocityDirToDegrees = (velocityDir * 180) / Math.PI + 180;
  // console.log(velocityDirToDegrees)
  velocityDirToDegrees += 180;
  if (velocityDirToDegrees >= 360) { velocityDirToDegrees -= 360; }
  return velocityDirToDegrees;
  }

  prepareChartData(data) {

    const temperatureChartData = {};
    for (let i = 0; i < 4; i++) {
      let component;
      const timestamps = Object.keys(data[i]);

      for (const ts of timestamps) {
        if (ts == 'Component') {
          component = data[i][ts];
          temperatureChartData[component] = [];
        } else if (component == 'TEMPERATURE') {
          const val = data[i][ts];
          // val = val.split("(")[0];
          const obj = {};
          obj['timestamp'] = ts;
          obj['temperature'] = Number(val);
          temperatureChartData[component].push(obj);
        } else if (component != 'TEMPERATURE') {
          const val = data[i][ts];
          temperatureChartData[component].push(Number(val));
        }
      }
    }

    let min = ProjConstants.MAX_INT;
    for (let number of temperatureChartData['TEMPERATURE']) {

      if (Number(number['temperature']) < min) {
        min = Number(number['temperature']);
      }
    }

    this.yAxisMin = min;
    this.chartTableData = this.prepareChartTableData(temperatureChartData['TEMPERATURE']);
    const temperatureArray = [];
    for (const value of temperatureChartData['TEMPERATURE']) {
      temperatureArray.push(value['temperature']);
    }

    return temperatureArray;
  }

  setChartOptions() {
    const data = {
      labels: this.bottomTableKeys,
      datasets: [{
        // label: 'Custom Label Name',
        backgroundColor: this.gradient,
        pointBackgroundColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        borderStyleCap: 'square',
        borderColor: 'rgba(0,0,0,0)',
        data: this.chartData
      }]
    };
    const options = {
      responsive: true,

      // maintainAspectRatio: true,
      animation: {
        easing: 'easeInOutQuad',
        duration: 520
      },

      scales: {
        xAxes: [{
          offset: true,
          display: false,
          gridLines: {
            color: 'rgba(200, 200, 200, 1)',
            lineWidth: 0
          },
          ticks: {
            labelOffset: '20px'
          }
        }],
        yAxes: [{
          display: false,
          gridLines: {
            color: 'rgba(200, 200, 200, 0.0)',
            lineWidth: 1
          },
          ticks: {
            suggestedMin: this.yAxisMin - 35,
          }
        }]
      },
      legend: {
        display: false
      },
      point: {
        backgroundColor: 'white'
      },
      tooltips: {
        enabled: false
      }
    };


    this.chartOptions = {
      type: 'line',
      data: data,
      options: options
    };
  }

  getColorForBottomBar(componentName, value) {
    if (value !== 'WIND' && value !== 'HUMIDITY' && value !== 'TEMPERATURE' && value !== 'RAINFALL') {
      if (componentName == 'WIND') {
        componentName = 'WINDSPEED';
      }
      if (componentName == 'TEMPERATURE') {
        let string = value.split('(', 2);
        value = string[0];
      }
      const backgroundColor = this.utils.getColorForBottomBar(componentName, Number(value));

      const styles = backgroundColor;
      const finalColor = this.utils.convertHexToRGBA(styles['background-color']);
      const obj = {};
      obj['background-color'] = finalColor;
      return obj;
    }
  }

  prepareBottomBarDays(data) {
    this.dateList = [];
    let index = 0;
    const timestamps = Object.keys(data[0]);
    for (const ts of timestamps) {
      if (ts == 'Component') {
        continue;
      } else {
        if (index % 8 == 0) {

          const date = new Date(Number(ts));
          const dates = date.toString().split(' ', 10);
          const finalDate = dates[0] + ' ' + dates[1] + ' ' + dates[2];
          this.dateList.push(finalDate);
        }
        index++;
      }
    }
  }

  closeBottomBar() {
    this.showBottomBar = !this.showBottomBar;
    this.showThrobberbottomBar = false;
    this.bottomBarColumns = ['Component'];
    this.chartData = [];
    this.bottomBarColumns = ['Component'];
    this.dateList = [];
    this.Linechart = new Chart('canvas', this.chartOptions).destroy();
    this.gradientStyles = {};
    this.closePopUp.emit(this.showBottomBar);
  }

  prepareChartTableData(data) {
    let temperatureValues = [];
    const greatest = {};
    let index = 1;
    greatest['temperature'] = -100;
    greatest['timestamp'] = '';
    while (index <= data.length) {
      if (index % 4 == 0) {
        const obj = {};
        Object.assign(obj, greatest);
        temperatureValues.push(obj);
        greatest['temperature'] = -100;
        greatest['timestamp'] = '';
      }
      if (data[index - 1]['temperature'] > greatest['temperature']) {
        Object.assign(greatest, data[index - 1]);
      }
      index++;
    }
    if (data.length % 4 != 0) {
      temperatureValues.push(greatest);
    }
    // sort all data based on timestamp
    temperatureValues = this.bubbleSort(temperatureValues);
    for (const value of temperatureValues) {
      value['timestamp'] = this.getDay(value['timestamp']);
    }
    return temperatureValues;
  }

  bubbleSort(temperatureValues) {
    for (let index = 0; index < temperatureValues.length; index++) {
      for (let index1 = 0; index1 < temperatureValues.length - 1; index1++) {
        if (Number(temperatureValues[index1]['timestamp']) > Number(temperatureValues[index1 + 1]['timestamp'])) {
          const swap = temperatureValues[index1];
          temperatureValues[index1] = temperatureValues[index1 + 1];
          temperatureValues[index1 + 1] = swap;
        }
      }
    }
    return temperatureValues;
  }

  getDay(timestamp) {
    const date = new Date(Number(timestamp));
    return this.getDayfromNumber(date.getDay());
  }

  getDayfromNumber(num) {
    switch (num) {
      case 0: return 'Sun';
        break;
      case 1: return 'Mon';
        break;
      case 2: return 'Tue';
        break;
      case 3: return 'Wed';
        break;
      case 4: return 'Thu';
        break;
      case 5: return 'Fri';
        break;
      case 6: return 'Sat';
        break;
    }
  }

  getAMPMTime(timestamp) {
    const date = new Date(timestamp-0);
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const anyminutes = minutes < 10 ? ('0' + minutes).toString() : minutes.toString();
    const strTime = hours + ':' + anyminutes + ' ' + ampm;
    // console.log("TIME", strTime);
    return strTime;
  }


}
